<template>
    <div class="card">
        <div class="header">
            <div class="title">编辑任务</div>
        </div>
        <div class="form">
            <form style="color: #adadad">
                <div class="form-group-list">
                    <InputField
                        label="任务编号"
                        type="text"
                        id="number"
                        :modelValue="form.number"
                        placeholder="请输入任务编号"
                        @update:modelValue="(value) => handleModelValueUpdate('number', value)"
                        required
                        disabled
                    />
                </div>
                <div class="form-group-list">
                    <InputField
                        label="任务名称"
                        type="text"
                        id="name"
                        :modelValue="form.name"
                        placeholder="请输入任务名称"
                        required
                        @update:modelValue="(value) => handleModelValueUpdate('name', value)"
                    />
                    <SelectField
                        label="任务类型"
                        id="type"
                        :modelValue="form.type"
                        :options="typeList"
                        required
                        labelWidth="40%"
                        @update:modelValue="(value) => handleModelValueUpdate('type', value)"
                    />
                </div>
                <div class="form-group-list">
                    <DatePickerField labelWidth="40%" label="任务日期"
                                     required name="taskTime" placeholder="请选择日期"
                                     :rules="[{ required: true, message: '请选择日期' }]"
                                     :modelValue="form.taskTime"
                                     id="taskTime"
                                     @update:modelValue="(value) => handleModelValueUpdate('taskTime', value)"
                    />
                    <SelectField
                        label="执行人"
                        id="executor"
                        :modelValue="form.executor"
                        :options="userList"
                        required
                        labelWidth="40%"
                        @update:modelValue="(value) => handleModelValueUpdate('executor', value)"
                    />
                </div>
                <div class="form-group-list form-group-list1">
                    <SelectField
                        label="任务说明"
                        id="remark"
                        :modelValue="form.remark"
                        :options="remarks"
                        required
                        labelWidth="13%"
                        multiple
                        @update:modelValue="(value) => handleModelValueUpdate('remark', value)"
                    />
                </div>
                <div class="form-group-list form-group-list1">
                    <SelectField
                        label="任务状态"
                        id="remark"
                        :modelValue="form.status"
                        :options="statusList"
                        required
                        labelWidth="13%"
                        @update:modelValue="(value) => handleModelValueUpdate('status', value)"
                    />
                </div>
                <div class="form-group-list">
                    <div class="form-group" style="width: 100%;margin-top: 10px">
                        <label class="form-label" for="facility" style="width: 13%;color: #94a3b8">
                            <span style="color: #ff5a5a;">*</span>任务设备
                        </label>
                        <div style="width: 100%; margin-top: 10px">
                            <ButtonField
                                    text="添加"
                                    @click="changeStatus('facility')"
                                    style="margin-bottom: 10px; width: 15%"
                                    secondary
                            />
                            <Tablelist
                                :showCheckbox="false"
                                :list="selectedFacilityList"
                                :columns="tableColumns"
                                @action="handleAction"
                            >
                                <template #template-category="{ item }">
                                    <span v-if="item.category === 'sewage'">污水</span>
                                    <span v-if="item.category === 'rain'">雨水</span>
                                    <span v-if="item.type === 'well'">检查井</span>
                                    <span v-else-if="item.type === 'pipe'">管线</span>
                                    <span v-else>
                                      <DataDictFinder dictType="deviceType" :dictValue="item.type" iconType="text" />
                                    </span>
                                </template>
                            </Tablelist>
                        </div>
                    </div>
                </div>
                <div class="form-group-button">
                    <ButtonField text="关闭" @click="cancel" secondary width="40%"/>
                    <ButtonField text="保存" primary width="40%"  @click="handleSubmit"/>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import { fetchDetail, edit  } from "../api/task";
import { fetchList } from "@/api/setting/user";
import { mapGetters } from "vuex";
import moment from "moment";
import request from "@/api/request";
import Tablelist from "@/components/water-affairs-style/table-list.vue";
import InputField from "@/components/water-affairs-style/field/InputField.vue";
import SelectField from "@/components/water-affairs-style/field/SelectField.vue";
import ButtonField from "@/components/water-affairs-style/field/ButtonField.vue";
function fetchRemarks() {
    return request({
        url: "/model-analysis/inspect/task/remark/list",
    });
}

export default {
    components: {Tablelist,InputField,SelectField,ButtonField},
    props: {
        selectedFacilityList: {
            type: Array,
            default: () => [
                {id:1,category:'sewage'},
                {id:2,category:'rain'},
                {id:3,category:'well'},
            ],
        },
        selectedMarkerList: {
            type: Array,
            default: () => [],
        },
    },
    watch: {
        form: {
            deep: true,
            handler(newVal) {
                console.log('form更新:', newVal);
            }
        }
    },
    data() {
        return {
            form: {
                number:'',
                name: '',
                type: '',
                taskTime: null,
                executor: '',
                remark: [],
                status: ''
            },
            user: {},
            showCheckbox:false,
            userList: [],
            remarks: [],
            text: {},
            tableColumns: [
                {
                    key: 'id',
                    title: '编号',
                    field: 'id',
                    infotype: 'text'
                },
                {
                    key: 'category',
                    title: '类型',
                    field: 'category',
                    infotype: 'template'
                },
                {
                    key: 'actions',
                    title: '操作',
                    render: {
                        view: false, edit: false, delete: true,audit:false
                    }
                }
            ]
        };
    },
    computed: {
        ...mapGetters("setting", ["findDataDict"]),
        typeList() {
            return this.findDataDict("taskType");
        },
        statusList() {
            return this.findDataDict("taskStatus");
        },
    },

    mounted() {

        fetchList({
            pageNum: 1,
            pageSize: 1000,
        }).then((res) => {
            if (res && Array.isArray(res.list)) {
                this.userList = res.list.map(item => ({
                    value: item.id,
                    name: item.name,
                }));
            }
        });

        const { id, type } = this.$route.query;
        if (id && type) {
            fetchDetail({ id, type }).then((res) => {
                console.log("detial", res);
                if (res) {
                    this.text = res;

                    this.form = {
                        id: res.id,
                        number: res.number,
                        name: res.name,
                        type: res.type,
                        taskTime: moment(res.taskTime, "YYYY-MM-DD"),
                        executor: res.executor,
                        remark: res.remark.split(" "),
                        status: res.status,
                    };
                    console.log(" this.form::", this.form)

                    if (Array.isArray(res.facilityList)) {
                        this.$emit(
                            "changeFacility",
                            res.facilityList.map((item) => {
                                return {
                                    ...item,
                                    id: item.deviceId,
                                    startLnglat: item.xfrom
                                        ? [item.xfrom, item.yfrom]
                                        : undefined,
                                    endLnglat: item.xto ? [item.xto, item.yto] : undefined,
                                };
                            })
                        );
                    }

                    if (Array.isArray(res.pointList)) {
                        this.$emit(
                            "changeMarker",
                            res.pointList.map((item) => {
                                return {
                                    ...item,
                                    x: parseFloat(item.x),
                                    y: parseFloat(item.y),
                                };
                            })
                        );
                    }
                }
            });
        }

        fetchRemarks().then((res) => {
            if (Array.isArray(res.list)) {
                this.remarks = res.list.map(item => ({
                    name: item.remark,
                    value: item.remark
                }));
                this.remarks = Object.freeze(this.remarks);
            }
        });
    },

    methods: {
        handleModelValueUpdate(fieldName, value) {
            this.form[fieldName] = value;
        },

        handleAction(actionData) {
            switch (actionData.type) {
                case 'delete':
                    this.deleteText(actionData.index);
                    break;
            }
        },
        changeStatus(payload) {
            this.$emit("changeStatus", payload);
            if (payload === "marker") {
                this.$message.info("请点击地图拾取点位");
            } else {
                this.$message.info("请选择设备");
            }
        },
        deleteText(index) {
            this.$emit("deleteFacility", index);
        },
        removeMarker(index) {
            this.$emit("removeMarker", index);
        },

        moment,

        handleSubmit() {
            if (this.isSubmitting) return;
            this.isSubmitting = true;
            if (!this.form.name) {
                this.$message.error('任务名称不能为空');
                this.isSubmitting = false; // 重置标志
                return;
            }
            if (!this.form.type) {
                this.$message.error('任务类型不能为空');
                this.isSubmitting = false;
                return;
            }
            if (!this.form.taskTime) {
                this.$message.error('任务日期不能为空');
                this.isSubmitting = false;
                return;
            }
            if (!this.form.executor) {
                this.$message.error('执行人不能为空');
                this.isSubmitting = false;
                return;
            }
            if (!this.form.remark.length) {
                this.$message.error('任务说明不能为空');
                this.isSubmitting = false;
                return;
            }
            const params = {
                ...this.form,
                taskTime: this.form.taskTime.format("YYYY-MM-DD"),
                executorName: this.userList.find((item) => item.id === this.form.executor)?.name,
                facilityList: this.selectedFacilityList.map((item) => {
                    return {
                        ...item,
                        deviceId: item.id,
                        id: undefined,
                    };
                }),
                remark: this.form.remark ? this.form.remark.join(" ") : "",
            };

            console.log(params);
            edit({
                id: this.text.id,
                ...params,
            }).then(() => {
                this.cancel();
            }).finally(() => {
                this.isSubmitting = false; // 无论成功或失败，重置标志
            });

        },

        cancel() {
            this.$router.go(-1);
        },
    },
};
</script>

<style lang="less" scoped>
.card {
  position: fixed;
  top: 11vh;
  right: 1vw;
  z-index: 99;
  width: 40vw;
   background-color: var(--detail-bgcolor);
  box-shadow: 0px 3px 10px rgba(0, 0, 0, 0.16);
  border-radius: 10px;
  height: 75vh;
  overflow: auto;

  & > .header {
    background-color: var(--default-bgcolor);
    position: sticky;
    top: 0;
    left: 0;
    z-index: 998;
    color: var(--cardText-color);
    font-weight: bold;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 1.5vw;
    line-height: 4vh;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
  }
}

.form {
  padding: 1em;

  .center {
    padding: 1em;
  }
}

.form-group-list{
  display: flex;
  justify-content: space-between;
  width: 95%;
}

.form-group {
  margin-bottom: 1.5rem;
  display: flex;
  align-items: center;
  width: 45%;
}

.form-group-list1 .form-group{
  width: 100%;
}
.form-group-list1 .form-label{
  width: 13%!important;
}

.form-group-button{
  display: flex;
  justify-content: space-between;
  width: 50%;
  margin: auto;
}

.filter-select {
  padding: 0.75rem 1rem;
  background: rgb(14 27 52);
  border: 1px solid rgba(0, 255, 150, 0.2);
  border-radius: 6px;
  color: #fff;
  font-size: 0.9rem;
  cursor: pointer;
  transition: all 0.3s ease;
  width: 90%;
}

.filter-select:focus {
  outline: none;
  border-color: #00ff96;
  box-shadow: 0 0 10px rgba(0, 255, 150, 0.2);
}

::v-deep .ant-calendar-picker-icon{
  color:rgb(148 163 184);
}
::v-deep .ant-input{
  background: rgb(14 27 52);
  border: 1px solid rgba(0, 255, 150, 0.2);
  border-radius: 6px;
  color: #fff;
  font-size: 0.9rem;
  cursor: pointer;
  transition: all 0.3s ease;
  height:46px;
}

</style>
